// Angular
import { Component, Input, OnInit, Injector, ViewChild } from '@angular/core';
// RxJS
import { Observable, BehaviorSubject } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../../core/auth';
import { AppComponentBase } from '../../../../../../shared/app-component-base';
import { AppAuthService } from '../../../../../../shared/auth/app-auth.service';
import { AfterViewInit } from '@angular/core';
import { UserCustomerServiceProxy, PagedResultDtoOfUserCustomerDto, UserCustomerDto } from '@shared/service-proxies/service-proxies';
import { MatDialog } from '@angular/material';
import { ChangeUsercustomerModalComponent } from '../../../../pages/transpop/usercustomer/change-usercustomer-modal/change-usercustomer-modal.component';
import { window } from 'ngx-bootstrap';
import { AppConsts } from '@shared/AppConsts';

export class ProfileMenu  {
	icon : string
	title : string
	subtitle : string
	navigateUrl: string
	auth: boolean 
}

@Component({
	selector: 'kt-user-profile3',
	templateUrl: './user-profile3.component.html',
	styleUrls: ['./user-profile3.component.scss']
})
export class UserProfile3Component extends AppComponentBase implements OnInit {

	// Public properties
	user$: Observable<User>;
	userFullName : string ;
	userName : string;
	userCopmany : string;
	profileMenuItems: ProfileMenu[] = [];
	profileMenuItemList = new BehaviorSubject<ProfileMenu[]>([]);
	customerLogoPath = new BehaviorSubject<string>("") ;

	pendingRequestsAuthorization: boolean = null;

	@Input() avatar = true;
	@Input() greeting = true;
	@Input() badge: boolean;
	@Input() icon: boolean;

	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(
		private store: Store<AppState>,
		injector: Injector,
		private _authService: AppAuthService,
		private _userCustomerService: UserCustomerServiceProxy,
		private _dialog: MatDialog,

	) {

			super(injector);


	}


	customerRowGuid;

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {

		//Burada ki GUID logonun projede ki asset dosyasında ki ilgili yeri görmesi ve o resmin key' ini barındırıyor.
		this.customerRowGuid = this.appSession.user.defaultCustomerRowGuid.toUpperCase();

		//Herhangi bir userCustomerTheme kullanilmamis ise, asagidaki konumdaki firma icin belirlenmis standart logo goruntulenir.
		this.customerLogoPath.next("assets/media/client-logos/" + this.customerRowGuid + ".png");

		
		//UserCustomerTheme tanimlanmis ise, theme uzerindeki firma logosu yuklenecektir.
		console.log("SESSINON USER");
		console.log(this.appSession.user);
		if (this.appSession.user.appCustomerThemeInfo){
			var userCustomerThemeCustomerLogo = this.appSession.user.appCustomerThemeInfo.customerLogoPath ;

			if (userCustomerThemeCustomerLogo != ""){
				this.customerLogoPath.next(AppConsts.userCustomerTheme.path + "/" + userCustomerThemeCustomerLogo) ;
			}
		}
		



		// console.log("user-profile3.components APPSESSION");
		// console.log("AppSession", this.appSession);
		//console.log("USER BILGILERI :" + this.appSession.user);

		//Buraya arkadan sessin içerisinde gelen isAprrove property si eklenecek
		this.pendingRequestsAuthorization = this.appSession.user.isUserApprover;
		let pageMyRequest = this.appSession.user.isUserOrderer;



		this.userName = this.appSession.user.userName;
		this.userFullName =  this.appSession.user.name + ' ' + this.appSession.user.surname;  //"Hasan AKYÜZ"; //this.appSession.getShownLoginName();
		this.userCopmany = this.appSession.user.defaultCustomerName;
		//this.userFullName =  this.appSession.getShownLoginName();
		//this.userFullName =  this.appSession.getShownLoginName();


		//console.log(this.appSession);
		
		//this.user$ = this.store.pipe(select(currentUser));
		
		this.profileMenuItems = [
			{ icon: "flaticon2-gear", title: "FE.HEADER.USER.PROFILE.ITEMS.ACCOUNT", subtitle: "FE.HEADER.USER.PROFILE.ITEMS.ACCOUNT.SUBHEADER", navigateUrl: "/app/user/profile", auth: true },			
			//{ icon: "flaticon2-gear", title: "Favori Ürünlerim", subtitle: "Favori ürünlerinizi yönetin.", navigateUrl: "/app/traspop/product/favorites", auth: true },
			{ icon: "flaticon2-gear", title: "FE.HEADER.USER.PROFILE.ITEMS.WAITINGFORAPPROVAL", subtitle: "FE.HEADER.USER.PROFILE.ITEMS.WAITINGFORAPPROVAL.SUBHEADER", navigateUrl: "/app/order/approve/2", auth: pageMyRequest },
			{ icon: "flaticon2-gear", title: "FE.HEADER.USER.PROFILE.ITEMS.WAITINGFORMYAPPROVAL", subtitle: "FE.HEADER.USER.PROFILE.ITEMS.WAITINGFORMYAPPROVAL.SUBHEADER", navigateUrl: "/app/order/approve/1", auth: this.pendingRequestsAuthorization },

		];

		//onayımı bekleyen talep yetkisi yok ise profileMenuItems içerisinden
		//false gelen değeri sil diyoruz.
		if (!this.pendingRequestsAuthorization) {
			var menuItemIndex = this.profileMenuItems.findIndex(x => x.auth == false);

			this.profileMenuItems.splice(menuItemIndex, 1);
		}

		if (!pageMyRequest) {
			var menuItemIndex = this.profileMenuItems.findIndex(x => x.auth == false);

			this.profileMenuItems.splice(menuItemIndex, 1);
		}

		this.profileMenuItemList.next(this.profileMenuItems);

		//ilgili kullanıcıya ait müşterileri getirir.
		this.getUserCustomers();
	}


	userCustomers = new BehaviorSubject<UserCustomerDto[]>([]);

	//kullanıcının müsteri listesini dönderir.
	getUserCustomers() {
		this._userCustomerService
			.getUserAssignedCustomers("", "", this.appSession.userId, 0, 1000)
			.subscribe((result: PagedResultDtoOfUserCustomerDto) => {

				console.log("CUSTOMER LISTESİ :" + result.items);
				this.userCustomers.next(result.items);

			});
	}

	//Varsayılan customerı değiştirmek çin kullanırız.
	onClickChangeDefaultCustomer(selectCustomer: UserCustomerDto, topbarHeaderDropElement) {

		console.log(selectCustomer);
		const dialogRef = this._dialog.open(ChangeUsercustomerModalComponent, { data: { selectCustomer } });
		topbarHeaderDropElement.open();

		dialogRef.afterClosed().subscribe(result => {
			console.log('Dialog Ref Result', result);
			if(result == true){
				//Gerekli işlem yapılacak.
				window.location.reload();
			}

			// topbarHeaderDropElement.close();

		});


	}
	
	/**
	 * Log out
	 */
	logout() {
		//this.store.dispatch(new Logout());
		this._authService.logout();
	}
}
